module.exports = __webpack_public_path__ + "static/img/viral_03.b1a4642c.jpg";